export default __webpack_public_path__ + "static/media/dash-logo.85ea48d2.svg";